import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import analytics from "../services/firebaseAnalytics";

/**
 * Hook to track button/element clicks
 *
 * @example
 * const trackClick = useAnalyticsClick();
 *
 * <IonButton onClick={() => {
 *   trackClick('login_button');
 *   handleLogin();
 * }}>
 */
export const useAnalyticsClick = () => {
  const location = useLocation();
  const currentScreen = location.pathname.replace("/", "") || "home";

  const trackClick = useCallback(
    async (
      elementName: string,
      additionalParams?: Record<string, string | number>
    ) => {
      await analytics.logClick(elementName, currentScreen, additionalParams);
    },
    [currentScreen]
  );

  return trackClick;
};
